import SearchResultsPage from '../components/SearchResultsPage';

/**
 * Reads the SSR-embedded initial search payload (SsrPageRenderer._injectIntoShell,
 * docs/seo-ssr-search-pages-design.md §10) so Hero can seed its state synchronously
 * instead of re-fetching /api/search. Returns null on the server (no `document`) and
 * on ordinary client renders where the script tag isn't present.
 */
function readInitialData() {
  if (typeof document === 'undefined') return null;
  const el = document.getElementById('__INITIAL_DATA__');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function SearchPage() {
  const initial = readInitialData();
  return (
    <SearchResultsPage
      searchTerm={initial?.searchTerm}
      searchResults={initial?.searchResults}
    />
  );
}

export default SearchPage;
